
import initSliders from './components/sliders'
import { initNav, initFooterNav } from './components/navigation'
import initFading from './components/fadeUp'
import initParallax from './components/parallax'
import initYoutubePlayers from './functions/youtube-player'
import initScroll from './components/scroll'
import initTypo from './components/typo'
import initBase from './components/base'

////////////////////////////////////////////////
// Events
////////////////////////////////////////////////
document.addEventListener("DOMContentLoaded", () => {
	initNav()
	initFooterNav()
	initFading()
	initParallax()
	initYoutubePlayers()
	initScroll()
	initTypo()
	initBase()
})
window.addEventListener("load", () => {
	// try to fix strange chrome bug
	initSliders()
})